var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import "./index.scss";
import React, { useState, useEffect } from "react";
import pubsub from "@viewlift/pubsub";
import localforage from "localforage";
import { SEARCH_EVENTS, SEARCH_KEYS } from "../../types/StandaloneSearchTypes";
import { NoResultToast } from "./NoResultToast";
import { SearchRow } from "./SearchRow";
import Spinner from "../../components/HomeLoadingScreen/Spinner";
import { useStandaloneSearchHelper } from "./index";
import { useLocation } from "react-router-dom";
import { Searchbox } from "./Searchbox";
import { getFontsStyles } from "../TrayModules/Helper/helper";
import { SearchTrayModule } from "../TrayModules/SearchTrayModule/SearchTrayModule";
export var StandaloneSearch = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var _p = useLocation(), state = _p.state, pathname = _p.pathname;
    var _q = props.moduleData.metadataMap, clearAllSearchText = _q.clearAllSearchText, myRecentSearchTitle = _q.myRecentSearchTitle, noResultFoundText = _q.noResultFoundText, topResultsTrayTitle = _q.topResultsTrayTitle;
    var _r = __read(useState(undefined), 2), pageData = _r[0], setPageData = _r[1];
    var _s = __read(useState(undefined), 2), topResultData = _s[0], setTopResultData = _s[1];
    var _t = __read(useState(false), 2), loading = _t[0], setLoading = _t[1];
    var _u = __read(useState(pathname.includes("/search")), 2), showSearchbox = _u[0], setShowSearchbox = _u[1];
    var showSearchBar = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.moduleData) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.settings) === null || _c === void 0 ? void 0 : _c.showSearchBar;
    var _v = __read(useState(""), 2), localTerm = _v[0], setLocalTerm = _v[1];
    var _w = __read(useState(false), 2), noData = _w[0], setNoData = _w[1];
    var _x = useStandaloneSearchHelper(), clearPreviousSearch = _x.clearPreviousSearch, getRecentSearchData = _x.getRecentSearchData;
    var fontSettings = (_e = (_d = props === null || props === void 0 ? void 0 : props.moduleData) === null || _d === void 0 ? void 0 : _d.layout) === null || _e === void 0 ? void 0 : _e.fontSetting;
    var moduleSettings = (_g = (_f = props === null || props === void 0 ? void 0 : props.moduleData) === null || _f === void 0 ? void 0 : _f.layout) === null || _g === void 0 ? void 0 : _g.settings;
    var trayTitle = getFontsStyles(fontSettings, moduleSettings).trayTitle;
    useEffect(function () {
        pubsub.subscribe(SEARCH_KEYS.LATEST_SEARCH_WORD, (function (_term) {
            setLocalTerm(_term);
        }));
    }, []);
    useEffect(function () {
        setNoData(false);
        pubsub.subscribe(SEARCH_KEYS.SEARCH_DATA, function (searchData) {
            var _a, _b, _c, _d;
            if (searchData) {
                var _searchData = JSON.parse(searchData);
                if (!((_c = (_b = (_a = (_searchData)) === null || _a === void 0 ? void 0 : _a.search) === null || _b === void 0 ? void 0 : _b.records) === null || _c === void 0 ? void 0 : _c.length)) {
                    setNoData(true);
                }
                else {
                    setTopResultData({ search: { records: (_d = _searchData === null || _searchData === void 0 ? void 0 : _searchData.search) === null || _d === void 0 ? void 0 : _d.records }, type: "curated" });
                }
            }
        });
    }, [localTerm]);
    useEffect(function () {
        setNoData(false);
        if (state === null || state === void 0 ? void 0 : state.searchTerm) {
            localforage.getItem(SEARCH_KEYS.SEARCH_DATA).then(function (res) {
                var _a, _b, _c;
                var _res = res;
                if (!((_c = (_b = (_a = _res === null || _res === void 0 ? void 0 : _res.data) === null || _a === void 0 ? void 0 : _a.search) === null || _b === void 0 ? void 0 : _b.records) === null || _c === void 0 ? void 0 : _c.length)) {
                    return setNoData(true);
                }
                setTopResultData({ search: __assign({}, _res.data.search), type: "curated" });
                pubsub.publish(SEARCH_EVENTS.REFRESH, JSON.stringify(_res.data));
            });
            window.history.replaceState({}, "");
        }
        return function () {
            window.history.replaceState({}, "");
            setTopResultData(undefined);
        };
    }, []);
    // * To get search history
    useEffect(function () {
        setLoading(true);
        getRecentSearchData()
            .then(function (recentData) {
            var _a;
            if (!recentData || ((_a = recentData === null || recentData === void 0 ? void 0 : recentData.items) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                setPageData(undefined);
            }
            else
                setPageData({ search: { records: recentData.items }, type: "recent" });
        })
            .catch(console.error)
            .finally(function () {
            return setLoading(false);
        });
        return function () {
            setLoading(false);
        };
    }, []);
    // * To remove search history
    useEffect(function () {
        pubsub.subscribe(SEARCH_EVENTS.DELETE, function () {
            setNoData(false);
            setPageData(undefined);
            setTopResultData(undefined);
        });
    }, []);
    if (loading)
        return React.createElement(Spinner, null);
    if (noData) {
        var messageText = noResultFoundText ? "".concat(noResultFoundText, " ").concat(localTerm) : '';
        return React.createElement(NoResultToast, { messageText: messageText || "There are no results for your search" });
    }
    return (React.createElement(React.Fragment, null,
        showSearchBar && React.createElement("div", { className: "standalone-search-box" },
            React.createElement(Searchbox, { visible: showSearchbox, manageVisibility: setShowSearchbox, placeholder: (_h = props.siteConfig.appcmsMain.genericMessages.emptySearchField) !== null && _h !== void 0 ? _h : "Search...", genericMessages: props.siteConfig.appcmsMain.genericMessages, showSearchbar: showSearchBar })),
        (!((_k = (_j = pageData === null || pageData === void 0 ? void 0 : pageData.search) === null || _j === void 0 ? void 0 : _j.records) === null || _k === void 0 ? void 0 : _k.length) && !((_m = (_l = topResultData === null || topResultData === void 0 ? void 0 : topResultData.search) === null || _l === void 0 ? void 0 : _l.records) === null || _m === void 0 ? void 0 : _m.length)) ? null : React.createElement("div", { className: "vl_search_page" },
            pageData && (pageData === null || pageData === void 0 ? void 0 : pageData.type) === "recent" ? (React.createElement(SearchRow, __assign({ titleFontConfig: trayTitle, showClearButton: pageData.type === "recent" ? true : false, clearCb: pageData.type === "recent"
                    ? function () {
                        setPageData(undefined);
                        clearPreviousSearch(SEARCH_KEYS.SEARCH_DATA);
                    }
                    : undefined, title: myRecentSearchTitle !== null && myRecentSearchTitle !== void 0 ? myRecentSearchTitle : "My Recent Searches", renderData: pageData, clearButtonLabel: clearAllSearchText !== null && clearAllSearchText !== void 0 ? clearAllSearchText : "Clear History" }, props))) : false,
            topResultData && (topResultData === null || topResultData === void 0 ? void 0 : topResultData.type) === "curated" ? (React.createElement(SearchRow, __assign({ titleFontConfig: trayTitle, showClearButton: false, title: topResultsTrayTitle !== null && topResultsTrayTitle !== void 0 ? topResultsTrayTitle : "Top Results", renderData: topResultData }, props))) : false,
            topResultData ? React.createElement(SearchTrayModule, { moduleData: props === null || props === void 0 ? void 0 : props.moduleData, contentData: { contentData: (_o = topResultData === null || topResultData === void 0 ? void 0 : topResultData.search) === null || _o === void 0 ? void 0 : _o.records } }) : null)));
};
